import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SubscribersState } from './subscribers.reducer';

export const selectSubscribersDataState = createFeatureSelector<SubscribersState>('subscribers');

export const selectSubscribersList = createSelector(
  selectSubscribersDataState,
  (state: SubscribersState) => { console.log('state', state);
   return state.list}
);

export const selectSubscribersPagination = createSelector(
  selectSubscribersDataState,
  (state: SubscribersState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectSubscribersDataLoading = createSelector(
    selectSubscribersDataState,
    (state: SubscribersState) => state.loading
);

export const selectSubscribersDataError = createSelector(
    selectSubscribersDataState,
    (state: SubscribersState) => state.error
);
